import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Modal from 'component/utils/Modal'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import TextArea from 'component/utils/TextArea'

const RemoveModal = ({
  closeModal,
  onSubmit,
  record,
  removalReasonList,
  translate,
}) => {
  const [idReason, setIdReason] = useState(1)
  const [showJustification, setShowJustification] = useState(false)
  const [dsRemoval, setDsRemoval] = useState(null)

  const beforeOnSubmit = (event) => {
    event.preventDefault()

    const values = {
      idReason,
      dsRemoval,
      nuOrder: record.header.orderNumber,
    }

    onSubmit(values)
  }

  const handleReasonChange = (event) => {
    const newReasonId = parseInt(event.target.value, 10)

    setIdReason(newReasonId)

    const newReason = removalReasonList.find(
      (reason) => reason.idReason === newReasonId
    )

    if (newReason.inInfo) {
      setShowJustification(true)
    } else {
      setShowJustification(false)
      setDsRemoval(null)
    }
  }

  const renderReasonList = (reason) => (
    <Field input={{}} key={reason.idReason}>
      <Input
        checked={idReason === reason.idReason}
        id={`idReason-${reason.idReason}`}
        label={translate(reason.dsReason)}
        onChange={(event) => handleReasonChange(event)}
        type='radio'
        value={reason.idReason}
      />
    </Field>
  )

  return (
    <Modal closeModal={closeModal} className='tracking-monitor-removeModal'>
      <form onSubmit={beforeOnSubmit}>
        <h3>{translate('totem.trackingMonitor.modal.remove.title')}</h3>
        <p>
          {`${translate('totem.trackingMonitor.modal.remove.content.1')} `}
          <strong>{record.header.orderNumber}</strong>
          {` ${translate('totem.trackingMonitor.modal.remove.content.2')}`}
        </p>
        <p>{translate('totem.trackingMonitor.modal.remove.content.3')}</p>

        {removalReasonList.map(renderReasonList)}

        {showJustification && (
          <TextArea
            label={translate('totem.trackingMonitor.modal.remove.label')}
            maxLength={240}
            onChange={(event) => setDsRemoval(event.target.value)}
          />
        )}

        <Row className='margin-top-quadruple'>
          <Col xs={3} xsOffset={3}>
            <button
              className='button button-default button-full'
              onClick={closeModal}
            >
              {translate('cancel_button')}
            </button>
          </Col>

          <Col xs={3}>
            <button className='button button-danger button-full'>
              {translate('exclude_button')}
            </button>
          </Col>
        </Row>
      </form>
    </Modal>
  )
}

RemoveModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  record: PropTypes.object.isRequired,
  removalReasonList: PropTypes.array.isRequired,
  translate: PropTypes.func.isRequired,
}

export default RemoveModal
